import { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faLaptopCode,
  faThumbsUp,
  faVolumeMute,
  faVolumeUp,
} from "@fortawesome/free-solid-svg-icons";
import SignUpModal from "./SignUpModal";

function BannerSliderCard({ item, hovered, hoveredId, isVideoPlaying }) {
  const videoRef = useRef(null);
  const [showSignUp, setShowSignUp] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false); // start muted by default (Netflix style)

  const handleVideoPlay = () => {
    console.log("video start");
    setVideoPlaying(true);
  };

  const handleVideoPause = () => {
    console.log("video paused");
    setVideoPlaying(false);
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };

  useEffect(() => {
    if (videoRef.current) {
      // Apply global play/pause from parent
      if (isVideoPlaying && hovered && hoveredId === item?.CourseId) {
        videoRef.current.play().catch((e) => console.log("Autoplay prevented:", e));
      } else {
        videoRef.current.pause();
      }

      // Keep muted state in sync
      videoRef.current.muted = isMuted;
    }
  }, [isVideoPlaying, hovered, hoveredId, item?.CourseId, isMuted]);

  // Optional: reset mute when card changes / hover ends
  useEffect(() => {
    if (!hovered || hoveredId !== item?.CourseId) {
      setIsMuted(false); // reset to muted when not hovered
    }
  }, [hovered, hoveredId, item?.CourseId]);

  return (
    <>
      <div className="banner-carousel-card position-relative overflow-hidden">
        {/* Background image shown when not hovered */}
        <img
          className="d-block w-100"
          src={item?.CourseImageURL200H}
          alt={item?.CourseTitle || "course banner"}
        />

        {/* Video overlay when hovered */}
        {hovered && hoveredId === item?.CourseId && (
          <div className="video-container position-absolute top-0 start-0 w-100 h-100">
            <video
              ref={videoRef}
              className="w-100 h-100 object-fit-cover"
              autoPlay={false} // controlled by useEffect
              muted={isMuted}   // initial mute
              loop
              playsInline
              poster={item?.CourseImageURL200H || "./images/videobanner.png"}
              onPlay={handleVideoPlay}
              onPause={handleVideoPause}
              onMouseLeave={handleVideoPause}
            >
              <source src={item?.CourseIntroVideoURL} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            {/* Mute/Unmute button – appears only when video is playing */}
            {videoPlaying && (
              <button
                className="btn btn-dark btn-sm rounded-circle position-absolute bottom-0 end-0 mb-3 me-3 p-2 shadow"
                onClick={toggleMute}
                aria-label={isMuted ? "Unmute video" : "Mute video"}
                style={{ zIndex: 10 }}
              >
                <FontAwesomeIcon
                  icon={isMuted ? faVolumeMute : faVolumeUp}
                  size="lg"
                />
              </button>
            )}
          </div>
        )}

        {/* Caption / overlay text */}
        <div
          className={`carousel-caption ${
            videoPlaying && hovered ? "fade-out" : ""
          }`}
        >
          <div className="caption-head">
            <h3>{item?.CourseTitle}</h3>
            <p>Get our amazing courses at affordable prices</p>
          </div>
          <div className="caption-tags">
            <div className="tag">
              <FontAwesomeIcon icon={faLaptopCode} />
              <span>41,304+ happy students</span>
            </div>
            <div className="tag">
              <FontAwesomeIcon icon={faBook} />
              <span>45+ courses</span>
            </div>
            <div className="tag">
              <FontAwesomeIcon icon={faThumbsUp} />
              <span>1,990+ reviews</span>
            </div>
          </div>
        </div>
      </div>

      {/* <SignUpModal show={showSignUp} handleClose={handleSignUpClose} /> */}
    </>
  );
}

export default BannerSliderCard;